import axios from 'axios';
import { isQuizComplete } from './vueQuizSvc'; 

export default {
  getAllColorMatches,
  getCustomerAnswers,
  getMoreColorOptions,
  getLightWorksRecommendations,
  getBoostRecommendations,
  persistCustomerAnswers,
  isAdvisorComplete,
};

function getAllColorMatches() {
  return axios.get('/api/advisor/getAllColorMatches');
}

function getCustomerAnswers() {
  return axios.get('/api/quiz/getCustomerAnswers');
}

function getMoreColorOptions() {
  return axios.get('/api/advisor/getMoreColorOptions');
}

function getLightWorksRecommendations() {
  return axios.get('/api/advisor/getLightWorksRecommendations');
}

function getBoostRecommendations(params) {
  return axios.get('/api/advisor/getBoostRecommendations', { params });
}

function persistCustomerAnswers(params) {
  return axios.post('/api/quiz/persistCustomerAnswers', params);
}

function isAdvisorComplete() {
  return isQuizComplete({ name: 'advisor' });
}
